import React from 'react';

import './TrashIcon.scss';

const TrashIcon = () => {
    return (
        <div className="component-TrashIcon">
            <svg
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g
                    id="design:-Bias-for-Reaction"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Exports"
                        transform="translate(-863.000000, -317.000000)"
                    >
                        <g
                            id="Icons/delete"
                            transform="translate(863.000000, 317.000000)"
                        >
                            <rect
                                id="Rectangle-Copy"
                                x="0"
                                y="0"
                                width="30"
                                height="30"
                            />
                            <g
                                id="Trash"
                                transform="translate(4.000000, 4.000000)"
                                fill="#8E9DB9"
                                fillRule="nonzero"
                            >
                                <path
                                    d="M6.8125,18.2108507 C6.8125,18.2117525 16.1889818,18.2105263 16.1889818,18.2105263 C16.1871669,18.2105263 16.1873515,9.44477642 16.1874603,6.57894737 L6.8125,6.57894737 L6.8125,18.2108507 Z M18.0625,18.2108507 C18.0625,19.1989706 17.2215061,20 16.1889818,20 L6.81101822,20 C5.77630268,20 4.9375,19.2006445 4.9375,18.2108507 L4.9375,6.57894704 C4.41965735,6.5785298 4,6.18154358 4,5.68421053 C4,5.19006101 4.41684143,4.78947368 4.93831718,4.78947368 L9.625,4.78947368 C9.625,3.80117466 10.4644661,3 11.5,3 C12.5355339,3 13.375,3.80117466 13.375,4.78947368 L18.0616828,4.78947368 C18.5799011,4.78947368 19,5.18661589 19,5.68421053 C19,6.17810189 18.583594,6.5785288 18.0625,6.57894704 L18.0625,18.2108507 Z M12.4375,9.260961 C12.4375,8.7680248 12.8536233,8.36842105 13.375,8.36842105 C13.892767,8.36842105 14.3125,8.7677523 14.3125,9.260961 L14.3125,15.5285127 C14.3125,16.0214489 13.8963767,16.4210526 13.375,16.4210526 C12.857233,16.4210526 12.4375,16.0217214 12.4375,15.5285127 L12.4375,9.260961 Z M8.6875,9.260961 C8.6875,8.7680248 9.10362327,8.36842105 9.625,8.36842105 C10.142767,8.36842105 10.5625,8.7677523 10.5625,9.260961 L10.5625,15.5285127 C10.5625,16.0214489 10.1463767,16.4210526 9.625,16.4210526 C9.10723305,16.4210526 8.6875,16.0217214 8.6875,15.5285127 L8.6875,9.260961 Z"
                                    id="Combined-Shape"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

TrashIcon.propTypes = {};

TrashIcon.defaultProps = {};

TrashIcon.displayName = 'TrashIcon';

export default TrashIcon;
